/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NegozioPatchForm { 
    version: number;
    nome: string;
    indirizzo: string;
    comune: string;
    pec: string;
    email: string;
    telefono: string;
}

